import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LayoutComponent } from './layout.component'
import { HeaderComponent } from './header/header.component'
import { SidebarComponent } from './sidebar/sidebar.component'
import { SharedModule } from './../../shared/shared.module'
import { LayoutRoutingModule } from './layout-routing.module'
import { OrganizationModule } from 'src/app/modules/organization/organization.module'
import { NotificationsModule } from 'src/app/modules/notifications/notifications.module'
import { OfferModule } from 'src/app/modules/offers/offer.module'
import { ClientsModule } from 'src/app/modules/clients/clients.module'
import { RatingsModule } from 'src/app/modules/rating/ratings.module'
import { PackageModule } from 'src/app/modules/packages/package.module'
import { RefundModule } from 'src/app/modules/refund/refund.module'
import { WalletModule } from 'src/app/modules/wallet/wallet.module'
import { PayoutModule } from 'src/app/modules/payout/payout.module'
import { ProductsModule } from 'src/app/modules/products/products.module'
import { ReviewsModule } from 'src/app/modules/reviews/reviews.module'
import { PointingSystemModule } from 'src/app/modules/pointing-system/pointing-system.module'
import { OrderReturnModule } from 'src/app/modules/order-return/order-return.module'
@NgModule({
	declarations: [LayoutComponent, SidebarComponent, HeaderComponent],
	imports: [
		CommonModule,
		LayoutRoutingModule,
		SharedModule,
		OrganizationModule,
		OfferModule,
		ClientsModule,
		RatingsModule,
		NotificationsModule,
		PackageModule,
		RefundModule,
		WalletModule,
		PayoutModule,
		ProductsModule,
		ReviewsModule,
		PointingSystemModule,
		OrderReturnModule
	],
})
export class LayoutModule {}
